module.exports = __webpack_public_path__ + "img/arrow-up.2bf1731e.svg";